// extracted by mini-css-extract-plugin
export default {"root":"_2mMj4","body-wrapper":"_1RS7S","bodyWrapper":"_1RS7S","big":"_2Atxb","postfix":"_3BYmy","small":"ceNPx","body-node":"_7HQTh","bodyNode":"_7HQTh"};